import { IkasProductAttributeValue } from ".";

export function initIkasProductAttributeValue(
  value: IkasProductAttributeValue
) {
  value.images = value.imageIds?.map((i) => ({ id: i, isVideo: false }));
}
